import React from 'react';
import { RouteProps } from 'react-router-dom';

// Brazil
import { BrazilGrowerDetailPage } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { BrazilGrowersPage } from 'features/brazil-grower/pages/BrazilGrowersPage';
import { CessionGroupDetailsPage } from 'features/brazil-grower/pages/CessionGroupDetailsPage/CessionGroupDetailsPage';
import { CessionGroupsListPage } from 'features/brazil-grower/pages/CessionGroupsListPage/CessionGroupsListPage';
import { BrazilContactDetailPage } from 'features/brazil-grower/pages/ContactDetailsPage/BrazilContactDetail';
import { UploadDocumentsPage } from 'features/brazil-grower/pages/UploadDocumentsPage/UploadDocumentsPage';
import { PricingManagementPage } from 'features/pricing/pages/PricingManagementPage/PricingManagementPage';
import { Reports } from 'features/reports/pages/Reports/Reports';

// Super
import { CampaignsPage } from 'features/admin/campaigns/pages/CampaignsPage/CampaignsPage';
import { PollingPage } from 'features/admin/polling/pages/Polling';
import { UserManagementPage } from 'features/admin/user-management/pages/UserManagement';
import { GrowerReportUpload } from 'features/upload-grower-data/pages/GrowerReportUpload/GrowerReportUpload';

// No role
import { NotificationPage } from 'features/brazil-grower/pages/NotificationPage/NotificationPage';
import { UnauthorizedPage } from 'features/general/pages/Unauthorized/Unauthorized';
import { HomePage } from 'features/home/pages/HomePage/HomePage';
import { NoMatch } from '../NoMatch/NoMatch';

import { Permissions, Scope } from 'shared';

export interface IRoute {
  // TODO change after all are FunctionComponents
  component: () => JSX.Element;
  options?: Partial<RouteProps>;
  path: string | string[];
  scope?: Scope;
  permission?: string;
  hideForPermissions?: string[];
}

/**
 * Country names codes alpha-2 can be found here https://www.iban.com/country-codes
 */

export const routes: IRoute[] = [
  {
    component: () => <HomePage />,
    options: {
      exact: true
    },
    path: '/'
  },
  {
    component: () => <UnauthorizedPage />,
    path: '/unauthorized'
  },
  {
    component: () => <BrazilGrowersPage />,
    options: {
      exact: true
    },
    path: '/br-growers',
    scope: Scope.BR
  },
  {
    component: () => <UploadDocumentsPage />,
    path: '/upload-documents/:id',
    scope: Scope.BR
  },
  {
    component: () => <BrazilContactDetailPage />,
    path: '/br-growers/:opportunityId/contacts/:contactId',
    scope: Scope.BR
  },
  {
    component: () => <BrazilGrowerDetailPage />,
    path: '/br-growers/:id',
    scope: Scope.BR
  },
  {
    component: () => <CessionGroupsListPage />,
    path: '/cessions',
    scope: Scope.BR,
    options: {
      exact: true
    },
    hideForPermissions: [
      Permissions.FA_EXTERNAL_LEGAL,
      Permissions.FA_EXTERNAL_CREDIT,
      Permissions.FA_EXTERNAL_FIELD_MONITORING,
      Permissions.FA_SECRETARY
    ]
  },
  {
    component: () => <CessionGroupDetailsPage />,
    path: '/cessions/:id',
    scope: Scope.BR,
    hideForPermissions: [
      Permissions.FA_EXTERNAL_LEGAL,
      Permissions.FA_EXTERNAL_CREDIT,
      Permissions.FA_EXTERNAL_FIELD_MONITORING,
      Permissions.FA_SECRETARY
    ]
  },
  {
    component: () => <Reports />,
    path: '/credit-lead-report',
    permission: Permissions.FA_CREDIT_LEAD,
    scope: Scope.BR
  },
  {
    component: () => <Reports />,
    path: '/terramagna-report',
    permission: Permissions.FA_EXTERNAL_FIELD_MONITORING,
    scope: Scope.BR
  },
  {
    component: () => <UserManagementPage />,
    path: '/user-management',
    permission: Permissions.FA_ADMIN,
    scope: Scope.GLOBAL
  },
  {
    component: () => <CampaignsPage />,
    path: '/campaigns-management',
    permission: Permissions.FA_ADMIN,
    scope: Scope.GLOBAL
  },
  {
    component: () => <PricingManagementPage />,
    path: '/pricing-management',
    scope: Scope.BR
  },
  {
    component: () => <GrowerReportUpload />,
    path: '/grower-report-upload',
    permission: Permissions.FA_ADMIN,
    scope: Scope.BR
  },
  {
    component: () => <PollingPage />,
    permission: Permissions.FA_ADMIN,
    scope: Scope.GLOBAL,
    path: '/salesforce-poll'
  },
  {
    component: () => <NotificationPage />,
    scope: Scope.BR,
    path: '/notifications'
  },
  {
    component: () => <NoMatch />,
    path: '*'
  }
];
